import {useEffect, useState} from "react";

import {sessionCache} from "@pg-rp/session-cache";

import {SEARCH_GUIDE_TOUR_STATE} from "../../app/constants/storage_keys";
import {useAppDispatch, useAppSelector} from "../../store/hooks";
import {completeStep, initializeTour, ISearchGuideTour, searchGuideTourSlice} from "../slices/search_guide_tour_slice";

interface IProps {
    name?: string;
}

interface ITourGuideStorageRecord {
    hasBeenSeen?: boolean;
}

export const useSearchGuideTour = (props: IProps) => {
    const dispatch = useAppDispatch();
    const [tourStorageState, setTourStorageState] = useState<ITourGuideStorageRecord | null>(null);

    const getTourStorageState = (): {[key in string]: ITourGuideStorageRecord} | null => {
        return sessionCache.get(SEARCH_GUIDE_TOUR_STATE) || null;
    };

    useEffect(() => {
        if (props.name) {
            setTourStorageState(getTourStorageState()?.[props.name] || {});
        }
    }, [props.name]);

    const saveTourStorageState = (state: ITourGuideStorageRecord) => {
        setTourStorageState(state);
        sessionCache.set(SEARCH_GUIDE_TOUR_STATE, {
            ...(getTourStorageState() || {}),
            [props.name || ""]: {...state}
        });
    };

    const guideTourCurrentStepId = useAppSelector((store) => {
        const tour = (store.search[searchGuideTourSlice.name] as ISearchGuideTour)[props.name || ""];
        const currentStepIndex = tour?.currentStepIndex;

        return typeof currentStepIndex === "number" ? tour?.steps[currentStepIndex]?.id : undefined;
    });
    const hasGuideTourBeenCompleted = useAppSelector((store) => {
        return !!(store.search[searchGuideTourSlice.name] as ISearchGuideTour)[props.name || ""]?.completed;
    });

    const tourExists = useAppSelector((store) => {
        return !!(store.search[searchGuideTourSlice.name] as ISearchGuideTour)[props.name || ""];
    });

    const startGuideTour = (steps: {id: number}[]) => {
        if (!props.name) {
            throw new Error("Search guide tour name is not defined");
        }

        saveTourStorageState({
            hasBeenSeen: true
        });
        dispatch(initializeTour({name: props.name, steps}));
    };

    const completeGuideTourStep = () => {
        if (props.name && tourExists) {
            dispatch(completeStep(props.name));
        }
    };

    return {
        startGuideTour,
        completeGuideTourStep,
        hasGuideTourBeenCompleted,
        guideTourCurrentStepId,
        tourStorageState,
        tourExists
    };
};
import {useEffect, useState} from "react";

import {sessionCache} from "@pg-rp/session-cache";

import {SEARCH_GUIDE_TOUR_STATE} from "../../app/constants/storage_keys";
import {useAppDispatch, useAppSelector} from "../../store/hooks";
import {completeStep, initializeTour, ISearchGuideTour, searchGuideTourSlice} from "../slices/search_guide_tour_slice";

interface IProps {
    name?: string;
}

interface ITourGuideStorageRecord {
    hasBeenSeen?: boolean;
}

export const useSearchGuideTour = (props: IProps) => {
    const dispatch = useAppDispatch();
    const [tourStorageState, setTourStorageState] = useState<ITourGuideStorageRecord | null>(null);

    const getTourStorageState = (): {[key in string]: ITourGuideStorageRecord} | null => {
        return sessionCache.get(SEARCH_GUIDE_TOUR_STATE) || null;
    };

    useEffect(() => {
        if (props.name) {
            setTourStorageState(getTourStorageState()?.[props.name] || {});
        }
    }, [props.name]);

    const saveTourStorageState = (state: ITourGuideStorageRecord) => {
        setTourStorageState(state);
        sessionCache.set(SEARCH_GUIDE_TOUR_STATE, {
            ...(getTourStorageState() || {}),
            [props.name || ""]: {...state}
        });
    };

    const guideTourCurrentStepId = useAppSelector((store) => {
        const tour = (store.search[searchGuideTourSlice.name] as ISearchGuideTour)[props.name || ""];
        const currentStepIndex = tour?.currentStepIndex;

        return typeof currentStepIndex === "number" ? tour?.steps[currentStepIndex]?.id : undefined;
    });
    const hasGuideTourBeenCompleted = useAppSelector((store) => {
        return !!(store.search[searchGuideTourSlice.name] as ISearchGuideTour)[props.name || ""]?.completed;
    });

    const tourExists = useAppSelector((store) => {
        return !!(store.search[searchGuideTourSlice.name] as ISearchGuideTour)[props.name || ""];
    });

    const startGuideTour = (steps: {id: number}[]) => {
        if (!props.name) {
            throw new Error("Search guide tour name is not defined");
        }

        saveTourStorageState({
            hasBeenSeen: true
        });
        dispatch(initializeTour({name: props.name, steps}));
    };

    const completeGuideTourStep = () => {
        if (props.name && tourExists) {
            dispatch(completeStep(props.name));
        }
    };

    return {
        startGuideTour,
        completeGuideTourStep,
        hasGuideTourBeenCompleted,
        guideTourCurrentStepId,
        tourStorageState,
        tourExists
    };
};
